import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearToast } from "../../redux/stores/GameStore";
import "./Toast.css";

export default function Toast() {
    const { toast } = useSelector(state => state.game);
    const dispatch = useDispatch();

    useEffect(() => {
        if (toast.message) {
            // Auto-dismiss after 5 seconds
            const timer = setTimeout(() => {
                dispatch(clearToast());
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [toast.id, toast.message, dispatch]);

    if (!toast.message) {
        return null;
    }

    const toastClass = `toast toast--${toast.type || 'error'}`;

    return (
        <div className={toastClass} role="alert">
            <div className="toast__content">
                <span className="toast__message">{toast.message}</span>
                <button 
                    className="toast__close" 
                    onClick={() => dispatch(clearToast())}
                    aria-label="Close notification"
                >
                    ×
                </button>
            </div>
        </div>
    );
}
